import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { ActionsMenuLayout } from '@wix/wix-ui-tpa/cssVars';
import {
  getManageOptions,
  getReportOption,
  getViewDownloadOptions,
} from './helper';
import { ITEM_MENU_OPTIONS } from '../../../../../../../../../Constants/ItemMenu.Constant';
import { st, classes } from '../ItemActionsMenu.st.css';
import useObservable from '../../../../../../../../../Shared/Hooks/useObservable.Hook';
import {
  getAppSettings,
  getSettingsData,
} from '../../../../../../../../Services/AppSettings.service';
import { TextAlignment } from '@wix/ambassador-file-sharing-v1-settings/types';
import useWidgetStyleParams from '../../../../../../../../Hooks/useWidgetStyleParams';

export const MenuOptions = ({
  handleOnClick,
  canManage,
  item,
  showPermissions,
  styleParams,
}: any) => {
  const { t } = useTranslation();
  const [, AppSettings]: any = useObservable(getAppSettings());
  const [, settingsData]: any = useObservable(getSettingsData());
  const rtlStatus = settingsData?.settings?.displaySettings?.textAlignment;
  const isRTL = rtlStatus === TextAlignment.RIGHT;
  const isMembersArea = AppSettings?.isMembersArea ?? false;
  const isMobile = AppSettings?.isMobile ?? '';
  const { isEditor3 } = useWidgetStyleParams();
  let options = [];

  const generateOptions = () => {
    const tempView = getViewDownloadOptions(t, isMembersArea);
    const tempReport = getReportOption(t);
    const dividerOption = { type: ITEM_MENU_OPTIONS.DIVIDER };
    let tempManage;
    if (canManage) {
      tempManage = getManageOptions(t, showPermissions, isMembersArea);
      options = [
        ...tempView,
        dividerOption,
        ...tempManage,
        dividerOption,
        ...tempReport,
      ];
    } else {
      options = [...tempView, dividerOption, ...tempReport];
    }
    let disabled = false;
    return options.map((option: any, index: number) => {
      disabled =
        option.type === ITEM_MENU_OPTIONS.DOWNLOAD &&
        item?.folderFields?.childrenCount <= 0;
      if (option.type === ITEM_MENU_OPTIONS.DIVIDER) {
        return (
          <ActionsMenuLayout.Divider
            key={`divider-${index}`}
            data-hook={`item-actions-menu-divider-${item.id}-${index}`}
          />
        );
      }
      return (
        <ActionsMenuLayout.Item
          key={option.type}
          content={option.content}
          onClick={() => handleOnClick(option.type)}
          disabled={disabled}
        />
      );
    });
  };

  return (
    <div style={styleParams}>
      <ActionsMenuLayout
        className={st(classes.actionsMenuLayoutContainer, {
          isMobile,
          isMembersArea,
          isRTL,
          isEditor3,
        })}
      >
        {generateOptions()}
      </ActionsMenuLayout>
    </div>
  );
};
